import React from "react";
import _ from "lodash";
import { NetworkAPI } from "apis";
import Select from "react-select";

let CACHE_SC = {};
let _isMounted = false;

class SensitiveCategoriesSelector extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      selectedValue: [],
      isLoading: false,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  async componentDidMount() {
    if (!this.props.networkId) return;

    _isMounted = true;
    try {
      const { networkId, targeting } = this.props;

      let options = null;
      if (CACHE_SC[networkId]) {
        options = CACHE_SC[networkId];
      } else {
        this.setState({ isLoading: true });
        const result = await NetworkAPI.getNetworkSensitiveCategories({
          networkId,
        });

        options = _.map(result, (category) => ({
          value: category.id,
          label: category.name,
        }));

        CACHE_SC[networkId] = options;
      }

      if (!_isMounted) return;
      this.setState({
        options,
        selectedValue: _.map(targeting, (id) => _.find(options, { value: id })),
        isLoading: false,
      });
    } catch (err) {
      console.error(err);
      this.setState({
        isLoading: false,
      });
    }
  }

  componentWillUnmount() {
    _isMounted = false;
  }

  handleChange(selectedOptions) {
    this.setState({ selectedValue: selectedOptions });
    this.props.onChange(selectedOptions.map((option) => option.value));
  }

  render() {
    const { isReadonly } = this.props;
    const { options, selectedValue, isLoading } = this.state;

    return (
      <div>
        {isReadonly && isLoading && (
          <div className="text-sm text-gray-800">Loading ...</div>
        )}
        {isReadonly ? (
          selectedValue.map((item, i) => {
            return (
              <div
                key={i}
                className="mb-1 mr-1 inline-block bg-gray-200 px-1 text-sm text-gray-800"
              >
                {`${item.value} ${item.label}`}
              </div>
            );
          })
        ) : (
          <Select
            isMulti
            options={options}
            value={selectedValue}
            onChange={this.handleChange}
            isLoading={isLoading}
            placeholder="Select sensitive categories..."
          />
        )}
      </div>
    );
  }
}

export default SensitiveCategoriesSelector;
